/**
 * Where the app opens: after signing in, after registering, at the end of the
 * onboarding wizard, and for any URL that matches nothing.
 *
 * One constant because those are four separate call sites that must agree — the
 * landing page was previously hardcoded in each of them.
 */
export const DEFAULT_ROUTE = "/customer-scans";
